var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "static-content-wrapper",
    {
      attrs: {
        designer: _vm.designer,
        field: _vm.field,
        "design-state": _vm.designState,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex,
        "sub-form-row-id": _vm.subFormRowId,
      },
    },
    [
      _c(
        "div",
        {
          ref: "fieldEditor",
          style: !!_vm.field.options.fontSize
            ? "font-size: " + _vm.field.options.fontSize + ";"
            : "",
        },
        [
          _c(
            "pre",
            {
              style: {
                "white-space": !!_vm.field.options.preWrap ? "pre-wrap" : "pre",
                "text-align": !!_vm.field.options.textAlign
                  ? _vm.field.options.textAlign
                  : "left",
              },
            },
            [_vm._v(_vm._s(_vm.field.options.textContent))]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }